import React from 'react';
import './PageHeader.css';

export default function PageHeader({
  title,
  totalCount,
  filteredCount,
  itemLabel = 'items',
  isMobile = false,
  titleAccessory = null,
  children
}) {
  return (
    <div className="page-header">
      <div className="page-header-title">
        <h1>{title}</h1>
        {titleAccessory}
      </div>
      <div className="header-content">
        {totalCount !== undefined && (
          <div className="header-stats">
            <span className="stat-badge">
              {filteredCount !== undefined && filteredCount !== totalCount 
                ? `${filteredCount} of ${totalCount} ${itemLabel}`
                : `${totalCount} ${itemLabel}`
              }
            </span>
          </div>
        )}
        {children && (
          <div className={`header-actions ${isMobile ? 'header-actions-mobile' : ''}`}>
            {children}
          </div>
        )}
      </div>
    </div>
  );
}